import React, { useState, useEffect } from "react";
import { Button } from "../../../components/Component";
const ButtonDisable = ({ ...props }) => {
    const [Count, setCount] = useState(0);
    const [isShown, setIsShown] = useState(false);
    const [Lorder, setLorder] = useState(true);
    const changepage = async (id) => {
        const sendData = {
            CatgTypeId: Number(id),

        }
     /*   //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    localStorage.setItem('userId', data.userId)
                    window.location.pathname = "/Dashboard"
                    /*props.history.push("/Dashboard")*/
                    setLorder(false)
                })


    };



    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            MonthId: Number(props.month),
            Month: String(props.catgtype),
        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/' + props.api, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                  /*  //console.log(data)*/
                    setCount(data)
                    setLorder(false)
                })


    };

    useEffect(() => {
        setLorder(true)
        getdata()
    }, [])


    return (
        <>{Count.edit + Count.submit !== 0 ? props.api =="Dgecount"?
            <td><Button color="primary" onClick={() => (sessionStorage.setItem("State", props.catgtype), window.location.pathname = "/State-Dashboard")}>View <em class="icon ni ni-eye-fill"></em></Button> </td> :
            props.api == "Statecount" ?
            <td><Button color="primary" onClick={() => (sessionStorage.setItem("Region", props.catgtype), window.location.pathname="/Reasonal-Dashboard")}>View <em class="icon ni ni-eye-fill"></em></Button> </td> :
            <td><Button color="primary" onClick={() => changepage(props.catgtype)}>View <em class="icon ni ni-eye-fill"></em></Button> </td>
            : <td><Button color="danger" disabled onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>{!isShown ? "View" : null}{isShown && (
                <div>
                    You cannot View this page.
                </div>
            )} <em class="icon ni ni-eye-fill"></em></Button> </td>}
            

        </>
    )
};

export default ButtonDisable;
